export function getRandomNumber(max = 99999999999999): number {
  return Math.floor(Math.random() * max);
}

export function isPowerOf2(x: number): boolean {
  const prev = x - 1;

  return x > 0 && !(x & prev);
}
